import { render, staticRenderFns } from "./Diagnose.vue?vue&type=template&id=587c07c4&scoped=true"
import script from "./Diagnose.vue?vue&type=script&lang=js"
export * from "./Diagnose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587c07c4",
  null
  
)

export default component.exports